/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intakestillprocessingone3Inputs */

const en_intakestillprocessingone3 = /** @type {(inputs: Intakestillprocessingone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 file uploaded · AI is still reading…`)
};

const pt_intakestillprocessingone3 = /** @type {(inputs: Intakestillprocessingone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 ficheiro carregado · A IA ainda está a ler…`)
};

/**
* | output |
* | --- |
* | "1 file uploaded · AI is still reading…" |
*
* @param {Intakestillprocessingone3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakestillprocessingone3 = /** @type {((inputs?: Intakestillprocessingone3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakestillprocessingone3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakestillprocessingone3(inputs)
	return pt_intakestillprocessingone3(inputs)
});
export { intakestillprocessingone3 as "intakeStillProcessingOne" }